import { createSlice } from '@reduxjs/toolkit';

export const outletSlice = createSlice({
	name: 'outlet',
	initialState: {
		totalRequests: 0
	},
	reducers: {		
		// Get All Outlet List
		getAllOutlets_request: (state) => {
			state.getAllOutlets_requesting = true;
			state.getAllOutlets_isSuccessful = undefined;

			state.allOutletList = undefined;
			state.allOutletListHeaders = undefined;
		},
		getAllOutlets_success: (state, action) => {
			state.getAllOutlets_requesting = false;
			state.getAllOutlets_isSuccessful = true;
			
			state.allOutletList = action.payload;
			state.allOutletListHeaders = action.payload?.headers;
		},
		getAllOutlets_failure: (state) => {
			state.getAllOutlets_requesting = false;
			state.getAllOutlets_isSuccessful = false;
		},

		// Get Outlet List
		getOutletSTList_request: (state) => {
			state.getOutletSTList_requesting = true;
			state.getOutletSTList_isSuccessful = undefined;
			state.outletSTList = undefined;
			state.outletSTListHeaders = undefined;
		},
		getOutletSTList_success: (state, action) => {
			state.getOutletSTList_requesting = false;
			state.getOutletSTList_isSuccessful = true;
			
			state.outletSTList = action?.payload?.data;
			state.outletSTListHeaders = action?.payload?.headers;
		},
		getOutletSTList_failure: (state) => {
			state.getOutletSTList_requesting = false;
			state.getOutletSTList_isSuccessful = false;
		},

		// Get All Outlet List
		getAllOutletSTList_request: (state) => {
			state.getAllOutletSTList_requesting = true;
			state.getAllOutletSTList_isSuccessful = undefined;
			state.allOutletSTList = undefined;
			state.allOutletSTListHeaders = undefined;
		},
		getAllOutletSTList_success: (state, action) => {
			state.getAllOutletSTList_requesting = false;
			state.getAllOutletSTList_isSuccessful = true;
			
			state.allOutletSTList = action?.payload?.data;
			state.allOutletSTListHeaders = action?.payload?.headers;
		},
		getAllOutletSTList_failure: (state) => {
			state.getAllOutletSTList_requesting = false;
			state.getAllOutletSTList_isSuccessful = false;
		},

		// Get Non-Deleted Outlets
		getNonDeletedOutlets_request: (state) => {
			state.getNonDeletedOutlets_requesting = true;
			state.getNonDeletedOutlets_isSuccessful = undefined;
			
			state.nonDeletedOutletList = undefined;
			state.nonDeletedOutletListHeaders = undefined;
		},
		getNonDeletedOutlets_success: (state, action) => {
			state.getNonDeletedOutlets_requesting = false;
			state.getNonDeletedOutlets_isSuccessful = true;
			
			state.nonDeletedOutletList = action.payload;
			state.nonDeletedOutletListHeaders = action.payload?.headers;
		},
		getNonDeletedOutlets_failure: (state) => {
			state.getNonDeletedOutlets_requesting = false;
			state.getNonDeletedOutlets_isSuccessful = false;
		},

		// Get Outlet Log
		getOutletLogs_request: (state) => {
			state.getOutletLogs_requesting = true;
			state.getOutletLogs_isSuccessful = undefined;

			state.outletLogs = undefined;
			state.outletLogsHeaders = undefined;
		},
		getOutletLogs_success: (state, action) => {
			state.getOutletLogs_requesting = false;
			state.getOutletLogs_isSuccessful = true;
			
			state.outletLogs = action?.payload?.data;
			state.outletLogsHeaders = action?.payload?.headers;
		},
		getOutletLogs_failure: (state) => {
			state.getOutletLogs_requesting = false;
			state.getOutletLogs_isSuccessful = false;
		},

		// Get All Outlet Log
		getAllOutletLogs_request: (state) => {
			state.getAllOutletLogs_requesting = true;
			state.getAllOutletLogs_isSuccessful = undefined;

			state.allOutletLogs = undefined;
			state.allOutletLogsHeaders = undefined;
		},
		getAllOutletLogs_success: (state, action) => {
			state.getAllOutletLogs_requesting = false;
			state.getAllOutletLogs_isSuccessful = true;
			
			state.allOutletLogs = action?.payload?.data;
			state.allOutletLogsHeaders = action?.payload?.headers;
		},
		getAllOutletLogs_failure: (state) => {
			state.getAllOutletLogs_requesting = false;
			state.getAllOutletLogs_isSuccessful = false;
		},

		// Activate Outlet
		activateOutlet_request: (state) => {
			state.activateOutlet_requesting = true;
			state.activateOutlet_isSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		activateOutlet_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);

			state.activateOutlet_requesting = !isDoneRequesting;
			state.activateOutlet_isSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		activateOutlet_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);

			state.activateOutlet_requesting = !isDoneRequesting;
			state.activateOutlet_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Suspend Outlet
		suspendOutlet_request: (state) => {
			state.suspendOutlet_requesting = true;
			state.suspendOutlet_isSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		suspendOutlet_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);

			state.suspendOutlet_requesting = !isDoneRequesting;
			state.suspendOutlet_isSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		suspendOutlet_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);

			state.suspendOutlet_requesting = !isDoneRequesting;
			state.suspendOutlet_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Delete Outlet
		deleteOutlet_request: (state) => {
			state.deleteOutlet_requesting = true;
			state.deleteOutlet_isSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		deleteOutlet_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);

			state.deleteOutlet_requesting = !isDoneRequesting;
			state.deleteOutlet_isSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		deleteOutlet_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);

			state.deleteOutlet_requesting = !isDoneRequesting;
			state.deleteOutlet_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Revert Deleted Outlet
		revertDeleteOutlet_request: (state) => {
			state.revertDeleteOutlet_requesting = true;
			state.revertDeleteOutlet_isSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		revertDeleteOutlet_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);

			state.revertDeleteOutlet_requesting = !isDoneRequesting;
			state.revertDeleteOutlet_isSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		revertDeleteOutlet_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);

			state.revertDeleteOutlet_requesting = !isDoneRequesting;
			state.revertDeleteOutlet_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Set Suspend Date
		setSuspendDate_request: (state) => {
			state.setSuspendDate_requesting = true;
			state.setSuspendDate_isSuccessful = undefined;
			state.isUpdateSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		setSuspendDate_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.setSuspendDate_requesting = !isDoneRequesting;
			state.setSuspendDate_isSuccessful = isDoneRequesting;
			state.isUpdateSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		setSuspendDate_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.setSuspendDate_requesting = !isDoneRequesting;
			state.setSuspendDate_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Remove Suspend Date
		removeSuspendDate_request: (state) => {
			state.removeSuspendDate_requesting = true;
			state.removeSuspendDate_isSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		removeSuspendDate_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.removeSuspendDate_requesting = !isDoneRequesting;
			state.removeSuspendDate_isSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		removeSuspendDate_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.removeSuspendDate_requesting = !isDoneRequesting;
			state.removeSuspendDate_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Add Outlet Activation Exclusion
		addOutletActivationExclusion_request: (state) => {
			state.addOutletActivationExclusion_requesting = true;
			state.addOutletActivationExclusion_isSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		addOutletActivationExclusion_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.addOutletActivationExclusion_requesting = !isDoneRequesting;
			state.addOutletActivationExclusion_isSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		addOutletActivationExclusion_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.addOutletActivationExclusion_requesting = !isDoneRequesting;
			state.addOutletActivationExclusion_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},

		// Remove Outlet Activation Exclusion
		removeOutletActivationExclusion_request: (state) => {
			state.removeOutletActivationExclusion_requesting = true;
			state.removeOutletActivationExclusion_isSuccessful = undefined;
			state.totalRequests = state.totalRequests + 1;
		},
		removeOutletActivationExclusion_success: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.removeOutletActivationExclusion_requesting = !isDoneRequesting;
			state.removeOutletActivationExclusion_isSuccessful = isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
		removeOutletActivationExclusion_failure: (state) => {
			let isDoneRequesting = (state.totalRequests == 1);
			state.removeOutletActivationExclusion_requesting = !isDoneRequesting;
			state.removeOutletActivationExclusion_isSuccessful = !isDoneRequesting;
			state.totalRequests = state.totalRequests - 1;
		},
	},
});

export const { 
	getAllOutlets_request, getAllOutlets_success, getAllOutlets_failure,
	getOutletSTList_request, getOutletSTList_success, getOutletSTList_failure,
	getAllOutletSTList_request, getAllOutletSTList_success, getAllOutletSTList_failure,
	getNonDeletedOutlets_request, getNonDeletedOutlets_success, getNonDeletedOutlets_failure,
	getOutletLogs_request, getOutletLogs_success, getOutletLogs_failure,
	getAllOutletLogs_request, getAllOutletLogs_success, getAllOutletLogs_failure,

	activateOutlet_request, activateOutlet_success, activateOutlet_failure,
	suspendOutlet_request, suspendOutlet_success, suspendOutlet_failure,
	deleteOutlet_request, deleteOutlet_success, deleteOutlet_failure,
	revertDeleteOutlet_request, revertDeleteOutlet_success, revertDeleteOutlet_failure,
	setSuspendDate_request, setSuspendDate_success, setSuspendDate_failure,
	removeSuspendDate_request, removeSuspendDate_success, removeSuspendDate_failure,
	addOutletActivationExclusion_request, addOutletActivationExclusion_success, addOutletActivationExclusion_failure,
	removeOutletActivationExclusion_request, removeOutletActivationExclusion_success, removeOutletActivationExclusion_failure,
} = outletSlice.actions;

export default outletSlice.reducer;